import { render, staticRenderFns } from "./ResourceCard.vue?vue&type=template&id=65e0f469"
import script from "./ResourceCard.vue?vue&type=script&lang=ts"
export * from "./ResourceCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports